import Vue from 'vue'
import Vuex from 'vuex'
// standardni volani vuci backendum
import BffAPI from '../service/BffAPI'
// mockovane volani
//import BffAPI from '../service/BffAPIMock'
import Analytics from '../service/Analytics'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		sso: '',
		jwt: '',
		response: null,
		lang: 'sk',
		accountType: null,
		isLoadingConsent: true,
		isProlongationDataLoaded: false,
		isAccountTypeLoaded: false,
		isB2B: false,
		hasProlongation: false,
		prolongationData: null,
		records: [],
		studentRecords: [],
		hwRecords: [],
	},
	getters: {
		accountType: (state) => () => {
			return state.accountType
		}
	},
	mutations: {
		SET_ACCOUNT_TYPE(state, data) {
			if (data) {
				state.accountType = data.accountType
			}
		},
		SET_IS_B2B(state, data) {
			if (data) {
				state.isB2B = data.accountType === 'B2B'
			}
		},
		SET_ACCOUNT_TYPE_LOADED(state, b) {
			state.isAccountTypeLoaded = b
		},
		SET_PROLONGATION_LOADED(state, b) {
			state.isProlongationDataLoaded = b
		},
		SET_PROLONGATION_INFO(state, data) {
			state.prolongationData = data
			if (data !== undefined && data !== null && data.manageableAssetList != null && data.manageableAssetList.length > 0) {
				state.records = data.manageableAssetList.filter(item => "STUDENT" !== item.subscriptionType && "NOCOMMITMENT" !== item.subscriptionType).map(x => createRecord(x))
				state.studentRecords = data.manageableAssetList.filter(item => "STUDENT" === item.subscriptionType).map(x => createRecord(x))
				state.hwRecords = data.manageableAssetList.filter(item => "NOCOMMITMENT" === item.subscriptionType).map(x => createRecord(x))
			}
			const recordsLength = state.records ? state.records.length : 0
			const hwRecordsLength = state.hwRecords ? state.hwRecords.length : 0
			const studentRecordsLength = state.studentRecords ? state.studentRecords.length : 0
			const sum = recordsLength + hwRecordsLength + studentRecordsLength
			const isStudent= studentRecordsLength === 1 && sum === 1
			state.hasProlongation = sum > 0 && !isStudent
		},
		SET_ERROR(state) {
			state.isLoadingConsent = false
			// for sure
			Analytics.setAnalyticTools(false)
		},
		SET_SSO_TOKEN(state, soo) {
			state.sso = soo
		},
		SET_JWT_TOKEN(state, token) {
			state.jwt = token
		},
		SET_CONSENT_LOADING(state, value) {
			state.isLoadingConsent = value
		},
		SET_I18N_LANGUAGE(state,params) {
			state.lang = params
		}
	},
	actions: {
		GET_ACCOUNT_TYPE(context) {
			BffAPI.getAccountType(context.state.jwt)
				.then(
					response => {
						context.commit('SET_ACCOUNT_TYPE', response)
						context.commit('SET_IS_B2B', response)
						context.commit('SET_ACCOUNT_TYPE_LOADED', true)
					}
				)
		},
		SET_LANGUAGE(context, query) {
			if (query.language !== undefined && query.language.length !== 0) {
				BffAPI.setLanguage(query.language)
				if (query.language === 'en') {
					context.commit('SET_I18N_LANGUAGE', 'en')
				}
			}
		},
		LOGIN_USER(context, query) {
			if (query.sso === undefined || query.sso.length === 0) {
				context.commit('SET_CONSENT_LOADING', false)
				Analytics.setAnalyticTools(false)
				// uzivatel neprisel s SSO tokenem - je na rozhodnuti, zdali mu nechat GA vypnute, nebo pouzit lepsi link, ktery mu sso do linku prida
				return;
			} else {
				context.commit('SET_SSO_TOKEN', query.sso)
			}
			const dat = {
				'ssoToken': query.sso
			}
			BffAPI.loginUser(dat)
			.then(
					data => {
						context.commit('SET_JWT_TOKEN', data)
						/*
						const params = {
							'data': data,
							'ssoToken': query.sso
						}
						context.dispatch('GOOGLE_ANALYTICS_SETUP', params)
						 */
						context.dispatch('GET_PROLONGATION_INFO')
						context.dispatch('GET_ACCOUNT_TYPE')
					}
			)
			.catch(
					error => {
						Analytics.setAnalyticTools(false)
						context.commit('SET_ERROR', error)
					}
			)
		},
		GET_PROLONGATION_INFO(context) {
			BffAPI.getAvailableUsers(context.state.jwt)
				.then(
					data => {
						context.commit('SET_PROLONGATION_INFO', data)
						context.commit('SET_PROLONGATION_LOADED', true)
					}
				)
				.catch(
					error => {
						context.commit('SET_ERROR', error)
					})
		},
	}
})


// private method for handle data
function createRecord(record) {

	var msisdn = record.msisdn
	if (msisdn.startsWith('420')) {
		msisdn = msisdn.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
		msisdn = msisdn.replace('420', '+420')
	}

	return {
		subscriberId: record.subscriberId,
		msisdn: msisdn,
		alias: record.alias,
		tariffName: record.tariffName,
		sid: record.eSid,
		onlyOne: record.onlyOne,
		subscriptionType: record.subscriptionType,
		availableOffering: record.availableOffering,
		activeOffering: record.activeOffering
	}
}